import { render, staticRenderFns } from "./OccupancyTab.vue?vue&type=template&id=e04c0758"
import script from "./OccupancyTab.vue?vue&type=script&setup=true&lang=js"
export * from "./OccupancyTab.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports